module.exports = __webpack_public_path__ + "img/no-img.2f39e4f9.jpg";